import React, { useEffect, useRef, useState } from "react";
import { ButtonDropdown, DropdownItem, DropdownMenu, DropdownToggle, Input, InputGroup } from "reactstrap";
import LoadingOverlay from "./LoadingOverlay";

interface Props {
    heading: string;
    type: number;
    listItems: any[];
    selectedIds: any[];
    setSelectedIds: any;
    handleSelectedPropertyOption: any;
    clearAll: any;
    addAll: any;
}

const MultiSelectSearch = (props: Props) => {
    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null); 

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        };
    
        document.addEventListener('mousedown', handleClickOutside);
    
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const toggleDropdown = (fromButtonClick?: boolean) => {
        if(fromButtonClick && !isOpen){
            setIsOpen(true);
        }
    };

    const filteredList = props.listItems.filter(item =>
        item.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleSearch = (event: any) => setSearchTerm(event.target.value);

    const handleSelectAll = async () => {
        setLoading(true);
        if (props.selectedIds.length === filteredList.length) {
            await props.clearAll();
        } else {
            await props.addAll();
        }
        setLoading(false);
    };

    return (
        <div ref={dropdownRef}>
            <ButtonDropdown isOpen={isOpen} toggle={() => toggleDropdown(true)} style={{ width: '100%' }}>
                <DropdownToggle caret style={{ backgroundColor: 'white', color: 'black', border: '1px solid #ced4da', width: '100%', textAlign: 'left', display: 'flex', alignItems: 'center' }}>
                    <div>{props.heading}</div>
                    <span style={{ marginLeft: 'auto' }} className="caret"></span>
                </DropdownToggle>
                <DropdownMenu style={{ maxHeight: '40vh', overflowY: 'auto', paddingTop: '0px' }}>
                    <div style={{ zIndex: 2, position: 'sticky', top: 0, width: '100%', height: '8px', background: 'white' }}></div>
                    <InputGroup className="mb-2 px-2" style={{ position: 'sticky', top: '8px', zIndex: 1, backgroundColor: 'white' }}>
                        <Input type="text" placeholder="Search..." value={searchTerm} onChange={handleSearch} />
                    </InputGroup>
                    <DropdownItem onClick={handleSelectAll}>
                        <input type="checkbox" checked={props.selectedIds.length === filteredList.length} readOnly /> Select All
                        <LoadingOverlay show={loading} inBootstrapColumn={true} />
                    </DropdownItem>
                    {/* Render selected items first */}
                    {props.selectedIds.map((selectedId: any) => {
                        const selectedItem = filteredList.find(item => item.id === selectedId);
                        if(selectedItem){
                            return (
                                <DropdownItem 
                                    key={selectedItem.id} 
                                    onClick={() => props.handleSelectedPropertyOption(selectedItem, props.type, props.selectedIds, props.setSelectedIds)} 
                                    active={props.selectedIds.includes(selectedItem.id)}
                                    id={`tooltip-${selectedItem.id}`}
                                >
                                    <input type="checkbox" checked={props.selectedIds.includes(selectedItem.id)} readOnly /> {selectedItem.name}
                                </DropdownItem>
                            );
                        }
                        return <></>
                        
                    })}
                    {props.selectedIds.length>0 && <div style={{ width: '100%', border: '0.5px grey solid', margin: '8px 0px 2px 0px'}}></div> }
                    {/* Render remaining items */}
                    {filteredList.map((option: any) => {
                        if (!props.selectedIds.includes(option.id)) {
                            return (
                                <DropdownItem 
                                    key={option.id} 
                                    onClick={() => props.handleSelectedPropertyOption(option, props.type, props.selectedIds, props.setSelectedIds)} 
                                    active={props.selectedIds.includes(option.id)}
                                    id={`tooltip-${option.id}`}
                                >
                                    <input type="checkbox" checked={props.selectedIds.includes(option.id)} readOnly /> {option.name}
                                    
                                </DropdownItem>
                            );
                        }
                        return null;
                    })}
                </DropdownMenu>
            </ButtonDropdown>
        </div>
    );
};

export default MultiSelectSearch;


// WEBPACK FOOTER //
// ./src/components/common/MultiSelectSearch.tsx